/*
 * Check if JWT Cookie set and then verify it
 */

import config from "../helpers/config";
import { RequestHelper } from "../helpers/requestHelper";

import { handleResponse } from "../helpers/handleResponse";

export const AssessmentService = {
  getAssessmentsByOrgId,
  addAssessmentsByOrgId,
  updateAssessmentsByOrgIdAndAssessmentId,
  getOverallAssessmentDataStudentsByOrgId,
  getOverallAssessmentDataTeachersByOrgId,
  deleteAssessmentByOrgIdAndAssessmentId,
};

function getAssessmentsByOrgId(orgId, options = {}) {
  const requestOptions = RequestHelper.getGetRequestOptions();

  var api_url = config.api_assessments_by_orgId;
  api_url =
    RequestHelper.replaceParams(api_url, {
      orgId: orgId,
    }) + RequestHelper.formatQueryString(options);

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.assessments;
    });
}

function getOverallAssessmentDataStudentsByOrgId(orgId, options = {}) {
  const requestOptions = RequestHelper.getGetRequestOptions();

  var api_url =
    config.api_assessments_by_orgId_overall_assessment_data_students;
  api_url =
    RequestHelper.replaceParams(api_url, {
      orgId: orgId,
    }) + RequestHelper.formatQueryString(options);

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.data;
    });
}

function getOverallAssessmentDataTeachersByOrgId(orgId, options = {}) {
  const requestOptions = RequestHelper.getGetRequestOptions();

  var api_url =
    config.api_assessments_by_orgId_overall_assessment_data_teachers;
  api_url =
    RequestHelper.replaceParams(api_url, {
      orgId: orgId,
    }) + RequestHelper.formatQueryString(options);

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.data;
    });
}

function addAssessmentsByOrgId(orgId, assessment) {
  const requestOptions = RequestHelper.getPostRequestOptions(assessment);

  var api_url = config.api_assessments_by_orgId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
  });
  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.assessment;
    });
}

function updateAssessmentsByOrgIdAndAssessmentId(
  orgId,
  assessmentId,
  assessment
) {
  const requestOptions = RequestHelper.getPutRequestOptions(assessment);

  var api_url = config.api_assessments_by_orgId_and_assessmentId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
    assessmentId: assessmentId,
  });
  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data.assessment;
    });
}

function deleteAssessmentByOrgIdAndAssessmentId(orgId, assessmentId) {
  const requestOptions = RequestHelper.getDeleteRequestOptions();

  var api_url = config.api_assessments_by_orgId_and_assessmentId;
  api_url = RequestHelper.replaceParams(api_url, {
    orgId: orgId,
    assessmentId: assessmentId,
  });

  //return Promise.reject(new Error());
  return fetch(api_url, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data._id;
    });
}
